import { useCallback, useState } from 'react';
import { message } from 'antd';
import type { StatisticsDateRange } from '../types/date-range';

export function useStatisticsDateRange(
  initialPeriod = 'all',
  initialRange: StatisticsDateRange = [null, null]
) {
  const [period, setPeriod] = useState(initialPeriod);
  const [dateRange, setDateRange] = useState<StatisticsDateRange>(initialRange);
  const [, refresh] = useState(0);
  const [from, to] = dateRange;

  const changePeriod = useCallback((value: string) => {
    setPeriod(value);
    setDateRange([null, null]);
  }, []);

  const applyDateRange = useCallback(
    (value: StatisticsDateRange) => {
      const [nextFrom, nextTo] = value;
      if (nextFrom && nextTo && nextFrom > nextTo) {
        message.error('Từ ngày phải nhỏ hơn hoặc bằng Đến ngày.');
        refresh((n) => n + 1);
        return;
      }
      if (
        nextFrom === from &&
        nextTo === to &&
        period === (nextFrom || nextTo ? 'custom' : 'all')
      )
        return;
      setDateRange([nextFrom, nextTo]);
      setPeriod(nextFrom || nextTo ? 'custom' : 'all');
    },
    [from, to, period]
  );

  return {
    period,
    dateRange,
    changePeriod,
    applyDateRange
  };
}
